(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _imagesloaded = require('imagesloaded');

var _imagesloaded2 = _interopRequireDefault(_imagesloaded);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 * Bricks - A responsive, justified image layout plugin written in
 * JavaScript, and inspired by Google Images.
 * v1.0.0
 * Arjan Jassal <hello@arjanjassal.com>
 * MIT License
 *
 */

var Bricks = function (imagesLoaded) {

	var defaults = {
		animation: true,
		animationDelay: 50,
		imageClassName: 'bricks__img',
		imageContainer: 'div',
		imageContainerClassName: 'bricks__item',
		imageLoadedClassName: 'bricks__img--loaded',
		margin: 0,
		maxHeight: 250
	};

	/**
  *
  * CLASS DEFINITION
  *
  */

	var Bricks = function () {
		function Bricks(elem, opts) {
			_classCallCheck(this, Bricks);

			this._elem = elem;
			this._opts = Object.assign(defaults, opts);
			this._images = Array.from(this._elem.querySelectorAll('.' + this._opts.imageClassName));
			this._init();
		}

		/**
   *
   * PRIVATE METHODS
   *
   */

		_createClass(Bricks, [{
			key: '_init',
			value: function _init() {
				this._checkOptions();
				this._addEventListeners();
				this._loadImages();
			}
		}, {
			key: '_checkOptions',
			value: function _checkOptions() {
				if (typeof this._opts.maxHeight !== 'number') {
					console.error('maxHeight must be a number not a ' + _typeof(this._opts.maxHeight) + '.');
				}

				if (this._opts.hasOwnProperty('beforeLoad')) {
					if (typeof this._opts.beforeLoad !== 'function') {
						console.error('beforeLoad must be a function not a ' + _typeof(this._opts.beforeLoad) + '.');
					}
				}

				if (this._opts.hasOwnProperty('afterLoad')) {
					if (typeof this._opts.afterLoad !== 'function') {
						console.error('afterLoad must be a function not a ' + _typeof(this._opts.afterLoad) + '.');
					}
				}

				if (this._opts.hasOwnProperty('imageContainer')) {
					if (typeof this._opts.imageContainer !== 'string') {
						console.error('imageContainer must be a string not a ' + _typeof(this._opts.imageContainer) + '.');
					}
				}
			}
		}, {
			key: '_addEventListeners',
			value: function _addEventListeners() {

				// Re-calculate image dimensions when the window is resized.
				window.addEventListener('resize', this._createRows.bind(this, this._images));
			}
		}, {
			key: '_loadImages',
			value: function _loadImages() {
				var _this = this;

				// Call beforeLoad().
				if (this._opts.beforeLoad) this._opts.beforeLoad();

				var imgLoad = imagesLoaded(this._elem);

				imgLoad.on('always', function (instance) {

					// Create rows of images.
					// Stagger animation of each images after layout is done.
					_this._createRows(_this._images, _this._showImages.bind(_this, instance.images));

					// Call afterLoad().
					if (_this._opts.afterLoad) _this._opts.afterLoad();

					// If the Bricks container has a height set on it, remove it after the images are loaded.
					_this._elem.style.removeProperty('height');
				});

				imgLoad.on('progress', function (instance, image) {
					var img = image.img;
					img.setAttribute('data-width', img.offsetWidth);
					img.setAttribute('data-height', img.offsetHeight);
				});
			}
		}, {
			key: '_createRows',
			value: function _createRows(images, callback) {
				var containerWidth = this._elem.clientWidth;
				var imgs = this._images;
				var slice = undefined,
				    height = undefined;

				loop: while (imgs.length > 0) {

					for (var i = 1; i <= imgs.length; i++) {
						slice = imgs.slice(0, i);
						height = this._getHeight(slice, containerWidth);

						if (height < this._opts.maxHeight) {
							this._setDimensions(slice, height);

							if (this._opts.margin > 0) this._setMargins(slice);

							for (var _i = 0; _i < slice.length; _i++) {
								if (!slice[_i].parentNode.classList.contains(this._opts.imageContainerClassName)) {
									this._makeImageContainer(slice);
								}
							}

							imgs = imgs.slice(i);
							continue loop;
						}
					}

					this._setDimensions(slice, Math.min(this._opts.maxHeight, height));
					if (this._opts.margin > 0) this._setMargins(slice);

					for (var i = 0; i < slice.length; i++) {
						if (!slice[i].parentNode.classList.contains(this._opts.imageContainerClassName)) {
							this._makeImageContainer(slice);
						}
					}

					break;
				}

				if (callback && typeof callback === 'function') {
					callback();
				}
			}
		}, {
			key: '_showImages',
			value: function _showImages(images) {
				var _this2 = this;

				var delay = 0;
				images.forEach(function (image) {
					var img = image.img;

					if (_this2._opts.animation && !img.classList.contains(_this2._opts.imageLoadedClassName)) {

						if (typeof _this2._opts.animationDelay !== 'number') {
							delay += parseInt(defaults.animationDelay);
							console.error('animationDelay must be a valid number.');
						} else {
							delay += parseInt(_this2._opts.animationDelay);
						}

						img.style.animationDelay = delay + 'ms';
						img.classList.add(_this2._opts.imageLoadedClassName);
					} else {
						img.style.animationDuration = '0ms';
						img.classList.add(_this2._opts.imageLoadedClassName);
					}

					_this2._animationComplete(img);

					// Log error to console if image fails to load.
					if (!image.isLoaded) {
						console.error(image.img.src + ' failed to load.');
					}
				});
			}
		}, {
			key: '_setDimensions',
			value: function _setDimensions(images, height) {
				if (images && Array.isArray(images)) {
					images.forEach(function (img, i) {
						var w = parseInt(img.getAttribute('data-width'));
						var h = parseInt(img.getAttribute('data-height'));

						img.style.width = height * (w / h) + 'px';
						img.style.height = height + 'px';
					});
				}
			}
		}, {
			key: '_setMargins',
			value: function _setMargins(images) {
				var _this3 = this;

				if (images && Array.isArray(images)) {
					images.forEach(function (img, i) {
						img.style.removeProperty('margin-right');
						if (i === images.length - 1) {
							return;
						} else {
							img.style.marginRight = _this3._opts.margin + 'px';
						}
					});
				}
			}
		}, {
			key: '_getHeight',
			value: function _getHeight(images, containerWidth) {
				var val = 0;
				var margin = this._opts.margin;

				if (margin > 0) {
					containerWidth -= images.length * margin;
					containerWidth += margin;
				}

				if (images && Array.isArray(images)) {
					images.forEach(function (img, i) {
						var w = parseInt(img.getAttribute('data-width'));
						var h = parseInt(img.getAttribute('data-height'));
						val += w / h;
					});
				}

				return containerWidth / val;
			}
		}, {
			key: '_animationComplete',
			value: function _animationComplete(img) {
				var completed = function completed() {
					img.style.removeProperty('animation-delay');
					img.removeEventListener('animationend', completed);
				};

				img.addEventListener('animationend', completed);
			}
		}, {
			key: '_makeImageContainer',
			value: function _makeImageContainer(images) {
				var _this4 = this;

				if (images && Array.isArray(images)) {
					images.forEach(function (img, i) {
						var el = _this4._opts.imageContainer;
						var item = _this4._makeDOMNode(el, _this4._opts.imageContainerClassName);

						if (el === 'a') {
							item.href = img.getAttribute('data-href') || '#';
						}

						item.appendChild(img);
						_this4._elem.appendChild(item);
					});
				}
			}
		}, {
			key: '_makeDOMNode',
			value: function _makeDOMNode(el, className) {
				var element = document.createElement(el);
				element.classList.add(this._opts.imageContainerClassName);
				return element;
			}

			/**
    *
    * PUBLIC METHODS
    *
    */

		}, {
			key: 'addNewImages',
			value: function addNewImages(images) {
				if (images && Array.isArray(images)) {
					var img = undefined;

					for (var i = 0, ii = images.length; i < ii; i++) {
						img = new Image();
						img.src = images[i];
						img.classList.add(this._opts.imageClassName);
						this._images.push(img);
						this._makeImageContainer([img]);
					}

					this._loadImages();
				} else {
					console.error('addNewImages only accepts an array of image paths.');
				}
			}
		}, {
			key: 'removeImages',
			value: function removeImages(images) {
				if (images && Array.isArray(images)) {
					for (var i = 0, ii = images.length; i < ii; i++) {
						var index = this._images.indexOf(images[i]);
						if (index > -1) this._images.splice(index, 1);
						images[i].parentElement.remove();
					}

					this._createRows(this._images);
				}
			}
		}, {
			key: 'reloadImages',
			value: function reloadImages() {
				var _this5 = this;

				var images = this._images;
				var srcs = [];

				// Clear the current images so there are no duplicates.
				this._images = [];

				// Add static height to container so the page doesn't move up when images are removed.
				this._elem.style.height = this._elem.clientHeight + 'px';

				images.forEach(function (img) {
					img.parentElement.remove();
					srcs.push(img.src);
				});

				setTimeout(function () {

					// Reload the images with the public method.
					_this5.addNewImages(srcs);

					// Empty the array so there aren't duplicates if this method is called more than once.
					srcs = [];
				}, 250);
			}
		}]);

		return Bricks;
	}();

	return Bricks;
}(_imagesloaded2.default);

exports.default = Bricks;
},{"imagesloaded":4}],2:[function(require,module,exports){
'use strict';

var _bricks = require('./bricks');

var _bricks2 = _interopRequireDefault(_bricks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugin = window.Bricks || _bricks2.default;
window.Bricks = plugin;
},{"./bricks":1}],3:[function(require,module,exports){
/**
 * EvEmitter v1.0.1
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners array
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || [];
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var i = 0;
  var listener = listeners[i];
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  while ( listener ) {
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
    // get next listener
    i += isOnce ? 0 : 1;
    listener = listeners[i];
  }

  return this;
};

return EvEmitter;

}));

},{}],4:[function(require,module,exports){
/*!
 * imagesLoaded v4.1.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

( function( window, factory ) { 'use strict';
  // universal module definition

  /*global define: false, module: false, require: false */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'ev-emitter/ev-emitter'
    ], function( EvEmitter ) {
      return factory( window, EvEmitter );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter')
    );
  } else {
    // browser global
    window.imagesLoaded = factory(
      window,
      window.EvEmitter
    );
  }

})( window,

// --------------------------  factory -------------------------- //

function factory( window, EvEmitter ) {

'use strict';

var $ = window.jQuery;
var console = window.console;

// -------------------------- helpers -------------------------- //

// extend objects
function extend( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
}

// turn element or nodeList into an array
function makeArray( obj ) {
  var ary = [];
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    ary = obj;
  } else if ( typeof obj.length == 'number' ) {
    // convert nodeList to array
    for ( var i=0; i < obj.length; i++ ) {
      ary.push( obj[i] );
    }
  } else {
    // array of single index
    ary.push( obj );
  }
  return ary;
}

// -------------------------- imagesLoaded -------------------------- //

/**
 * @param {Array, Element, NodeList, String} elem
 * @param {Object or Function} options - if function, use as callback
 * @param {Function} onAlways - callback function
 */
function ImagesLoaded( elem, options, onAlways ) {
  // coerce ImagesLoaded() without new, to be new ImagesLoaded()
  if ( !( this instanceof ImagesLoaded ) ) {
    return new ImagesLoaded( elem, options, onAlways );
  }
  // use elem as selector string
  if ( typeof elem == 'string' ) {
    elem = document.querySelectorAll( elem );
  }

  this.elements = makeArray( elem );
  this.options = extend( {}, this.options );

  if ( typeof options == 'function' ) {
    onAlways = options;
  } else {
    extend( this.options, options );
  }

  if ( onAlways ) {
    this.on( 'always', onAlways );
  }

  this.getImages();

  if ( $ ) {
    // add jQuery Deferred object
    this.jqDeferred = new $.Deferred();
  }

  // HACK check async to allow time to bind listeners
  setTimeout( function() {
    this.check();
  }.bind( this ));
}

ImagesLoaded.prototype = Object.create( EvEmitter.prototype );

ImagesLoaded.prototype.options = {};

ImagesLoaded.prototype.getImages = function() {
  this.images = [];

  // filter & find items if we have an item selector
  this.elements.forEach( this.addElementImages, this );
};

/**
 * @param {Node} element
 */
ImagesLoaded.prototype.addElementImages = function( elem ) {
  // filter siblings
  if ( elem.nodeName == 'IMG' ) {
    this.addImage( elem );
  }
  // get background image on element
  if ( this.options.background === true ) {
    this.addElementBackgroundImages( elem );
  }

  // find children
  // no non-element nodes, #143
  var nodeType = elem.nodeType;
  if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
    return;
  }
  var childImgs = elem.querySelectorAll('img');
  // concat childElems to filterFound array
  for ( var i=0; i < childImgs.length; i++ ) {
    var img = childImgs[i];
    this.addImage( img );
  }

  // get child background images
  if ( typeof this.options.background == 'string' ) {
    var children = elem.querySelectorAll( this.options.background );
    for ( i=0; i < children.length; i++ ) {
      var child = children[i];
      this.addElementBackgroundImages( child );
    }
  }
};

var elementNodeTypes = {
  1: true,
  9: true,
  11: true
};

ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    // Firefox returns null if in a hidden iframe https://bugzil.la/548397
    return;
  }
  // get url inside url("...")
  var reURL = /url\((['"])?(.*?)\1\)/gi;
  var matches = reURL.exec( style.backgroundImage );
  while ( matches !== null ) {
    var url = matches && matches[2];
    if ( url ) {
      this.addBackground( url, elem );
    }
    matches = reURL.exec( style.backgroundImage );
  }
};

/**
 * @param {Image} img
 */
ImagesLoaded.prototype.addImage = function( img ) {
  var loadingImage = new LoadingImage( img );
  this.images.push( loadingImage );
};

ImagesLoaded.prototype.addBackground = function( url, elem ) {
  var background = new Background( url, elem );
  this.images.push( background );
};

ImagesLoaded.prototype.check = function() {
  var _this = this;
  this.progressedCount = 0;
  this.hasAnyBroken = false;
  // complete if no images
  if ( !this.images.length ) {
    this.complete();
    return;
  }

  function onProgress( image, elem, message ) {
    // HACK - Chrome triggers event before object properties have changed. #83
    setTimeout( function() {
      _this.progress( image, elem, message );
    });
  }

  this.images.forEach( function( loadingImage ) {
    loadingImage.once( 'progress', onProgress );
    loadingImage.check();
  });
};

ImagesLoaded.prototype.progress = function( image, elem, message ) {
  this.progressedCount++;
  this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
  // progress event
  this.emitEvent( 'progress', [ this, image, elem ] );
  if ( this.jqDeferred && this.jqDeferred.notify ) {
    this.jqDeferred.notify( this, image );
  }
  // check if completed
  if ( this.progressedCount == this.images.length ) {
    this.complete();
  }

  if ( this.options.debug && console ) {
    console.log( 'progress: ' + message, image, elem );
  }
};

ImagesLoaded.prototype.complete = function() {
  var eventName = this.hasAnyBroken ? 'fail' : 'done';
  this.isComplete = true;
  this.emitEvent( eventName, [ this ] );
  this.emitEvent( 'always', [ this ] );
  if ( this.jqDeferred ) {
    var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
    this.jqDeferred[ jqMethod ]( this );
  }
};

// --------------------------  -------------------------- //

function LoadingImage( img ) {
  this.img = img;
}

LoadingImage.prototype = Object.create( EvEmitter.prototype );

LoadingImage.prototype.check = function() {
  // If complete is true and browser supports natural sizes,
  // try to check for image status manually.
  var isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    // report based on naturalWidth
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    return;
  }

  // If none of the checks above matched, simulate loading on detached element.
  this.proxyImage = new Image();
  this.proxyImage.addEventListener( 'load', this );
  this.proxyImage.addEventListener( 'error', this );
  // bind to image as well for Firefox. #191
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.proxyImage.src = this.img.src;
};

LoadingImage.prototype.getIsImageComplete = function() {
  return this.img.complete && this.img.naturalWidth !== undefined;
};

LoadingImage.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.img, message ] );
};

// ----- events ----- //

// trigger specified handler for event type
LoadingImage.prototype.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

LoadingImage.prototype.onload = function() {
  this.confirm( true, 'onload' );
  this.unbindEvents();
};

LoadingImage.prototype.onerror = function() {
  this.confirm( false, 'onerror' );
  this.unbindEvents();
};

LoadingImage.prototype.unbindEvents = function() {
  this.proxyImage.removeEventListener( 'load', this );
  this.proxyImage.removeEventListener( 'error', this );
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

// -------------------------- Background -------------------------- //

function Background( url, element ) {
  this.url = url;
  this.element = element;
  this.img = new Image();
}

// inherit LoadingImage prototype
Background.prototype = Object.create( LoadingImage.prototype );

Background.prototype.check = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.img.src = this.url;
  // check if image is already complete
  var isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    this.unbindEvents();
  }
};

Background.prototype.unbindEvents = function() {
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

Background.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.element, message ] );
};

// -------------------------- jQuery -------------------------- //

ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
  jQuery = jQuery || window.jQuery;
  if ( !jQuery ) {
    return;
  }
  // set local variable
  $ = jQuery;
  // $().imagesLoaded()
  $.fn.imagesLoaded = function( options, callback ) {
    var instance = new ImagesLoaded( this, options, callback );
    return instance.jqDeferred.promise( $(this) );
  };
};
// try making plugin
ImagesLoaded.makeJQueryPlugin();

// --------------------------  -------------------------- //

return ImagesLoaded;

});

},{"ev-emitter":3}]},{},[2])

